// Static projects data
export const projects = [
  {
    _id: '1',
    title: 'Cantilever Shade Design - Green',
    description: 'Modern cantilever shade structure with single-sided support system, offering unobstructed parking space and maximum usability. Features high-quality steel frame and UV-resistant fabric for durable, long-lasting protection.',
    image: '/images/cantilever-green.jpg',
    images: ['/images/cantilever-green.jpg'],
    location: 'Kitui, Kenya',
    completionDate: new Date('2024-11-15'),
    details: 'This cantilever shade design features a sleek green finish that complements modern architectural styles. The single-sided support eliminates multiple columns, providing easy vehicle access and impressive open space. Perfect for residential parking, commercial spaces, and car yards.'
  },
  {
    _id: '2',
    title: 'Cantilever Shade Design - Blue',
    description: 'Premium cantilever shade structure in elegant blue, combining modern aesthetics with superior functionality. Built with high-strength materials to withstand harsh weather conditions while maintaining structural integrity.',
    image: '/images/cantilever-blue.jpg',
    images: ['/images/cantilever-blue.jpg'],
    location: 'Kitui, Kenya',
    completionDate: new Date('2024-10-20'),
    details: 'The blue cantilever design offers a sophisticated appearance while delivering reliable protection against UV rays and environmental elements. Its aerodynamic structure ensures excellent wind resistance and efficient water drainage. Ideal for premium residential and commercial properties.'
  },
  {
    _id: '3',
    title: 'Privacy Screen Fence',
    description: 'Elegant privacy screen fence designed to enhance security and maintain a clean, modern appearance. Weather-resistant materials ensure long-term durability with minimal maintenance requirements.',
    image: '/images/privacy-screen.jpg',
    images: ['/images/privacy-screen.jpg'],
    location: 'Machakos, Kenya',
    completionDate: new Date('2024-09-30'),
    details: 'This privacy screen fence effectively blocks unwanted views while reducing ambient noise. Made from premium, weather-resistant materials, it provides reliable performance for residential compounds, commercial properties, and outdoor spaces. Combines functionality with refined aesthetics.'
  }
];

export default projects;
